import Vue from "vue";
import axios from "axios";
import users from "../../users";
import jwtTokenHandler from "@/jwtTokenHandler";
import moment from "moment";

const portalProfileDef = {
  None: { name: "None", type: 0 },
  Employee: { name: "Employee Portal", type: 1 },
  Customer: { name: "Customer Portal", type: 2 },
};
const portalTextDef = {
  None: { name: "None", type: 0 },
  EmployeeAccountDescription: {
    name: "Employee Account Description",
    type: 40,
  },
  CustomerAccountDescription: { name: "Customer Account Description", type: 3 },
};

export default {
  name: "Login",
  mixins: [users, jwtTokenHandler],
  components: {
    EmailComp: require("../../components/email.vue").default,
    NewPasswordComp: require("../../components/newPassword.vue").default,
    TermsConditionsComp: require("../terms/terms.vue").default,
  },
  data: function () {
    return {
      brandingLoginSecondaryColorText: "",
      brandingAccentColor: "",
      brandingColor: "",
      brandingLoginPrimaryColor: "",
      brandingLoginPrimaryColorText: "",
      brandingLoginSecondaryColor: "",
      registration: false,
      resetPassword: false,
      bShowTerms: false,
      accountName: "",
      id: "",
      mobileNo: "",
      regMessage: "",
      email: { email: "", valid: false },
      passwords: { password: "", password2: "", canContinue: false },
      trustedComputer: false,
      registrationCompleted: false,
      sendPasswordCompleted: false,
      messages: { error: "" },
      isInComm: false,
      bValidateCustomerAccountEmail: true,
      bValidateCustomerAccountIdNo: true,
      bValidateEmployeeAccountIdNo: true,
      bValidateCustomerAccountMobileNo: false,
      bSelectAccount: false,
      bStrongPassword: false,
      regAccDescription: "",
      settings: { welcomeMsg: "Welcome", orgShortName: "" },
      termsAgreed: false,
      showDialog: false,
      portalProfileType: portalProfileDef.Customer.type,
      oidcModel: null,
      portalAuthenticationType: 0,
      profileStatus: -1,
      utilitySettings: null,
      otpCodeSent: false,
      otpCode: "",
      loginBox: null,
      optBox: null,
    };
  },
  computed: {
    loginEnabled: function () {
      return (
        this.email.valid && this.passwords.password.length > 0 && !this.isInComm
      );
    },
    registerEnabled: function () {
      return (
        this.email.valid &&
        this.passwords.canContinue &&
        this.accountName.length > 0 &&
        (this.bValidateCustomerAccountIdNo === true ||
        this.bValidateEmployeeAccountIdNo === true
          ? this.id.length > 0
          : true) &&
        (this.bValidateCustomerAccountMobileNo === true
          ? this.mobileNo.length > 0
          : true) &&
        !this.isInComm &&
        this.termsAgreed
      );
    },
    resetPasswordEnabled: function () {
      return this.email.valid && !this.isInComm && !this.sendPasswordCompleted;
    },
    languageLocale: function () {
      return this.$i18n.locale;
    },
  },
  created() {
    this.getSettings();
    this.getTermsBox();
    this.getPortalWelcomeMessage();

    this.brandingLoginPrimaryColor =
      this.$localStorage.get("brandingLoginPrimaryColor") ?? "";
    this.brandingLoginSecondaryColor =
      this.$localStorage.get("brandingLoginSecondaryColor") ?? "";

    if (this.brandingLoginPrimaryColor)
      this.brandingLoginPrimaryColorText = `color: ${this.brandingLoginPrimaryColor} !important`;

    if (this.brandingLoginSecondaryColor)
      this.brandingLoginSecondaryColor = `background-color: ${this.brandingLoginSecondaryColor} !important`;

    this.brandingColor =
      "background-color: " + this.$localStorage.get("brandingColor");
    this.brandingAccentColor =
      "color: " + this.$localStorage.get("brandingAccentColor");
    this.brandingLoginSecondaryColorText =
      "color: " + this.$localStorage.get("brandingSecondaryColor");
  },
  mounted() {},
  watch: {
    languageLocale: function (value) {
      this.getRegisterAccountDescription();
      this.getRegisterMessage();
      this.getPortalWelcomeMessage();
    },
    timeBeginMinutes: function (value) {
      this.appData.periodBeginMin = value;
    },
    timeEndHours: function (value) {
      this.appData.periodEndHH = value;
    },
    timeEndMinutes: function (value) {
      this.appData.periodEndMin = value;
    },
  },
  methods: {
    setFocus() {
      var el;
      if (this.resetPassword || !this.registration)
        if (
          this.$refs.login.$el.children &&
          this.$refs.login.$el.children.length > 0 &&
          this.$refs.login.$el.children[0].children &&
          this.$refs.login.$el.children[0].children.length > 1
        )
          el = this.$refs.login.$el.children[0].children[1];
        else el = this.$refs.register.$el;
      Vue.nextTick(function () {
        if (el) el.focus();
      });
    },
    getTermsBox() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Utility/GetSettings")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.bShowTerms = response.data.value.isShowTermsAndConditions;
            this.termsAgreed =
              this.bShowTerms === false ? true : this.termsAgreed;
          }
        })
        .finally(loader.hide());
    },
    toggleRegistration() {
      this.registration = !this.registration;
      if (!this.registration) this.sendPasswordCompleted = false;
      this.setFocus();
    },
    togglePasswordReset() {
      this.resetPassword = !this.resetPassword;
      this.setFocus();
    },
    onEnterClick: function () {
      alert("Enter was pressed");
    },
    signin() {
      if (
        !this.utilitySettings ||
        this.utilitySettings.employeeLoginOtpWithEmail == null ||
        this.utilitySettings.employeeLoginOtpWithSms == null
      ) {
        this.$alertMsg(this.$t("messages.loginError"));
        setTimeout(() => {
          location.reload();
        }, 3000);
        return;
      }

      if (
        ((this.utilitySettings &&
          this.utilitySettings.employeeLoginOtpWithEmail != null &&
          this.utilitySettings.employeeLoginOtpWithEmail === true) ||
          (this.utilitySettings.employeeLoginOtpWithSms != null &&
            this.utilitySettings.employeeLoginOtpWithSms === true)) &&
        this.otpCodeSent != null &&
        this.otpCodeSent === false
      ) {
        this.sendOtpCode(true);
        return;
      }

      this.isInComm = true;
      var parameter = {
        Email: this.email.email.toLowerCase(),
        Password: this.passwords.password,
        OtpCode: this.otpCode,
        TrustedComputer: true, //this.trustedComputer
      };

      if (this.utilitySettings && this.utilitySettings.jwtAuthorization)
        parameter["Logintype"] = 1;

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/account/Login", parameter)
        .then((response) => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            let totalMinutesValid = 0;
            this.$store.commit("setIsFieldWorker", false);

            //check date
            if (response.data.jwtTokenExpiration) {
              const expirationMoment = moment.utc(
                response.data.jwtTokenExpiration
              );
              const currentMoment = moment.utc();

              // Calculate time difference using moment
              const duration = moment.duration(
                expirationMoment.diff(currentMoment)
              );

              if (duration.asMilliseconds() > 0) {
                // Get the total number of minutes as final variable
                totalMinutesValid = Math.floor(duration.asMinutes());
              }
            }

            // Validate login response has required JWT fields
            if (!response.data.jwtToken || !response.data.jwtTokenExpiration) {
              console.warn("Login response missing JWT fields:", {
                hasJwtToken: !!response.data.jwtToken,
                hasJwtTokenExpiration: !!response.data.jwtTokenExpiration,
                responseKeys: Object.keys(response.data),
              });
            }

            this.saveJwtToken(
              response.data.jwtToken,
              response.data.jwtTokenExpiration,
              totalMinutesValid / 2
            );

            setTimeout(() => {
              this.$localStorage.set("_login", this.email.email);
              this.$root.$emit("user_loggedin");
            }, 1000);
          } else this.$alertMsg(response.data.data.text);
          loader.hide();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data.data.text);
          this.$router.push("/login");
          loader.hide();
        });
      //.catch(e => {
      //  console.log(e);
      //  this.$router.push('/login');
      //  loader.hide();
      //})
    },
    register() {
      this.isInComm = true;
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/account/RegisterProfile", {
          Email: this.email.email,
          AccountName: this.accountName,
          Password: this.passwords.password,
          IdNo: this.id,
          SendOtpCode: false,
        })
        .then((response) => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.registrationCompleted = true;
          } else this.$alertMsg(response.data.data.text);
          loader.hide();
        })
        .catch((e) => {
          this.$router.push("/register");
          loader.hide();
        });
    },
    sendPassword() {
      this.isInComm = true;
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/account/SendResetUserPassword", { Email: this.email.email })
        .then((response) => {
          this.isInComm = false;
          loader.hide();
          if (response.data.data.status == 0) {
            this.sendPasswordCompleted = true;
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$router.push("/register");
          loader.hide();
        });
    },
    getPortalWelcomeMessage() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Utility/GetPortalWelcomeMessage", { Value: this.$i18n.locale })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.settings = response.data.settings;
          }
        })
        .finally(loader.hide());
    },
    getRegisterAccountDescription() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 40, //(this.portalProfileType == portalProfileDef.Customer.type) ? portalTextDef.CustomerAccountDescription.type : portalTextDef.EmployeeAccountDescription.type
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.regAccDescription = response.data.settings.text;
        }
      });
    },
    getRegisterMessage() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 65 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.regMessage = response.data.settings.text;
          }
        });
    },
    getSettings() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Utility/GetSettings")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.utilitySettings = response.data.value;

            this.portalProfileType = response.data.value.portalProfileType;
            this.bSelectAccount = response.data.value.isSelectAccount;

            this.bValidateCustomerAccountEmail =
              response.data.value.isValidateCustomerAccountEmail;
            this.bValidateCustomerAccountEmail =
              this.portalProfileType === portalProfileDef.Customer.type
                ? this.bValidateCustomerAccountEmail
                : false;

            this.bValidateCustomerAccountIdNo =
              response.data.value.isValidateCustomerAccountIdNo;
            this.bValidateCustomerAccountIdNo =
              this.portalProfileType === portalProfileDef.Customer.type
                ? this.bValidateCustomerAccountIdNo
                : false;

            this.bValidateEmployeeAccountIdNo =
              response.data.value.isValidateEmployeeAccountIdNo;
            this.bValidateEmployeeAccountIdNo =
              this.portalProfileType === portalProfileDef.Employee.type
                ? this.bValidateEmployeeAccountIdNo
                : false;

            this.bValidateCustomerAccountMobileNo =
              response.data.value.isValidateCustomerAccountMobileNo;
            this.bValidateCustomerAccountMobileNo =
              this.portalProfileType === portalProfileDef.Customer.type
                ? this.bValidateCustomerAccountMobileNo
                : false;

            this.bStrongPassword = response.data.value.strongPassword;

            this.portalAuthenticationType =
              response.data.value.portalAuthenticationType;

            this.getRegisterAccountDescription();
            this.getRegisterMessage();
          }
        })
        .finally(loader.hide());
    },
    sendOtpCode(switchBoxes) {
      this.$store.state.notifier.asyncBlock(
        axios.post("/account/LoginWithOtpStage1", {
          Email: this.email.email,
          Password: this.passwords.password,
        }),
        (response) => {
          if (response.status == 200) {
            this.otpCodeSent = true;
            this.$alertMsg(this.$t("messages.otpCodeSentSuccessfully"), 2);

            if (switchBoxes) this.switchLoginAndOtp();
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
      ),
        "OPT Code sending";
    },
    switchLoginAndOtp() {
      const loginBox = document.querySelector(".login-box");
      const otpBox = document.querySelector(".otp-box");

      if (loginBox.classList.contains("hidden")) {
        loginBox.classList.remove("hidden");
        setTimeout(function () {
          loginBox.classList.remove("visuallyhidden");
        }, 20);
      } else {
        loginBox.classList.add("visuallyhidden");
        loginBox.addEventListener(
          "transitionend",
          function (e) {
            loginBox.classList.add("hidden");
          },
          {
            capture: false,
            once: true,
            passive: false,
          }
        );
      }

      if (otpBox.classList.contains("hidden")) {
        otpBox.classList.remove("hidden");
        setTimeout(function () {
          otpBox.classList.remove("visuallyhidden");
        }, 20);
      } else {
        otpBox.classList.add("visuallyhidden");
        otpBox.addEventListener(
          "transitionend",
          function (e) {
            otpBox.classList.add("hidden");
          },
          {
            capture: false,
            once: true,
            passive: false,
          }
        );
      }
    },
  },
};
